'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _selectors = require('../../../../store/selectors');

var _helpers = require('../../../../helpers/');

var _ValidationInputs = require('./ValidationInputs');

var _ValidationInputs2 = _interopRequireDefault(_ValidationInputs);

require('./Condition.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _antd.Form.Item;
var find = require('lodash/collection/find');

var Condition = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(Condition, _React$Component);

  function Condition() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Condition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Condition.__proto__ || (0, _getPrototypeOf2.default)(Condition)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      form: {
        fact: null,
        operator: null,
        value: {
          valueJson: null,
          valueDecimal: null,
          valueString: null
        }
      }
    }, _this.isFormValid = function () {
      if (typeof _this.state.isValid !== 'undefined') return _this.state.isValid;
      return (0, _helpers.isConditionValid)(_this.state.form);
    }, _this.onFactChange = function (value) {
      var newState = (0, _assign2.default)({}, _this.state);
      newState.form = {
        fact: value[2],
        operator: null,
        valueJson: null,
        valueString: null,
        valueDecimal: null
      };
      newState.isValid = null;
      _this.setState(newState);
    }, _this.onOperatorChange = function (item) {
      var newState = (0, _assign2.default)({}, _this.state);
      newState.form.operator = item.key;
      _this.setState(newState);
    }, _this.cancelSaveCondition = function () {
      var _this$props = _this.props,
          conditionActions = _this$props.conditionActions,
          condition = _this$props.condition,
          conditionGroupID = _this$props.conditionGroupID,
          ruleBranchID = _this$props.ruleBranchID;
      var id = condition.id,
          fact = condition.fact,
          operator = condition.operator,
          valueJson = condition.valueJson,
          valueDecimal = condition.valueDecimal,
          valueString = condition.valueString;
      // existing condition

      _this.updateValidationInputsValidation(true);
      if ((0, _helpers.isConditionValid)(condition)) {
        _this.setState({
          form: {
            fact: fact,
            operator: operator,
            valueJson: valueJson,
            valueDecimal: valueDecimal,
            valueString: valueString
          }
        }, function () {
          conditionActions.cancelEdit(id);
        });
      } else {
        conditionActions.remove(condition.id, conditionGroupID, ruleBranchID);
      }
    }, _this.saveCondition = function () {
      var _this$props2 = _this.props,
          condition = _this$props2.condition,
          conditionActions = _this$props2.conditionActions,
          conditionGroupID = _this$props2.conditionGroupID,
          ruleBranchID = _this$props2.ruleBranchID;

      var form = (0, _assign2.default)({}, _this.state.form);
      conditionActions.cancelEdit(condition.id);
      conditionActions.update(condition.id, conditionGroupID, ruleBranchID, {
        fact: form.fact,
        operator: form.operator,
        valueJson: form.valueJson,
        valueDecimal: form.valueDecimal,
        valueString: form.valueString
      });
    }, _this.onValidationInputsChange = function (parent) {
      var parseValues = function parseValues(values) {
        var parsed = (0, _assign2.default)({}, values);
        if (values.location) {
          parsed.loc = parseInt(values.location.key, 10);
          parsed.locLabel = values.location.label;
        }
        delete parsed.location;
        return parsed;
      };

      if (parent) {
        return function (values) {
          var parsedValues = parseValues(values);
          var opType = _this.state.form[parent] ? '$merge' : '$set';
          _this.setState({ form: (0, _immutabilityHelper2.default)(_this.state.form, (0, _defineProperty3.default)({}, parent, (0, _defineProperty3.default)({}, opType, parsedValues))) });
        };
      }
      return function (values) {
        var parsedValues = parseValues(values);
        _this.setState({ form: (0, _immutabilityHelper2.default)(_this.state.form, {
            $merge: parsedValues
          }) });
      };
    }, _this.updateValidationInputsValidation = function (isValid, updateStore) {
      var _this$props3 = _this.props,
          ruleBranchID = _this$props3.ruleBranchID,
          conditionGroupID = _this$props3.conditionGroupID,
          condition = _this$props3.condition,
          builderActions = _this$props3.builderActions;

      _this.setState({ isValid: isValid }, function () {
        if (updateStore === true) {
          builderActions('updateEntitiesValidation', {
            ruleBranches: ruleBranchID,
            conditionGroups: conditionGroupID,
            conditions: condition.id
          }, isValid);
        }
      });
    }, _this.renderOperatorsMenu = function (opType) {
      var operators = _this.props.meta.operators.data[opType];
      var defaultSelectedKeys = _this.state.form.operator ? [_this.state.form.operator] : [];
      var menuItems = operators.map(function (operator, index) {
        return _react2.default.createElement(
          _antd.Menu.Item,
          { key: operator.value, value: operator.value },
          operator.label
        );
      });

      return _react2.default.createElement(
        _antd.Menu,
        { onClick: _this.onOperatorChange, defaultSelectedKeys: defaultSelectedKeys },
        menuItems
      );
    }, _this.editView = function () {
      var fact = _this.state.form.fact;
      var meta = _this.props.meta;

      var triggersLoading = meta.loading ? { hasFeedback: true, validateStatus: "validating", disabled: true } : {};

      /**
       * On init, the component hydrates its local state's
       * values with the condition data (trigger, operator, etc). This
       * provides ease-of-use since we just need to track changes made
       * to the local state and run validation on those values.
       * Due to the backend response structure, when loading a condition
       * from backend, we are provided with unique IDs for the condition
       * data. In the case of trigger selection (cascader ant component)
       * during edit, we need to build the array which will be used as
       * defaultValue for cascader in order to populate the loaded
       * trigger from the backend.
       */
      var cascaderDefaultValue = [];
      var triggerEntity = {};

      /**
       * If the local state's form trigger value is valid, build out
       * the defaultValue which will be used by cascader. While doing
       * this, we also obtain the actual trigger object, which will be
       * needed for operator selection.
       */
      if (_this.state.form.fact) {
        cascaderDefaultValue = (0, _helpers.getCascaderPathToEntityBy)('alias', fact, meta.cascaderTriggersOptions, true);
        triggerEntity = cascaderDefaultValue[2];
        cascaderDefaultValue[2] = fact;
      } else {
        cascaderDefaultValue = [];
      }

      var factMarkup = _react2.default.createElement(_antd.Cascader, {
        disabled: triggersLoading.disabled,
        options: meta.cascaderTriggersOptions,
        onChange: _this.onFactChange,
        placeholder: 'Search or select trigger',
        defaultValue: cascaderDefaultValue,
        style: { width: '100%' },
        displayRender: function displayRender(label) {
          return label[2];
        },
        showSearch: {
          filter: function filter(inputValue, path) {
            return path.some(function (option) {
              return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
            });
          },
          matchInputWidth: false
        }
      });

      /**
       * Let's render the operator field markup only if the fact
       * field is valid.
       */
      var operatorMarkup = void 0;
      if (_this.state.form.fact) {
        var operator = _this.state.form.operator;

        var operatorObject = void 0;
        var selectLabel = void 0;
        var _triggerEntity = triggerEntity,
            filterOpType = _triggerEntity.filterOpType;

        if (_this.state.form.operator) {
          operatorObject = find(_this.props.meta.operators.data[filterOpType], { value: operator });
          selectLabel = operatorObject.label;
        } else {
          selectLabel = 'select';
        }
        var operatorMenu = _this.renderOperatorsMenu(filterOpType);
        operatorMarkup = _react2.default.createElement(
          _antd.Dropdown,
          { overlay: operatorMenu, key: _this.state.form.fact + '-operator', trigger: ['click'], getPopupContainer: _this.getPopupContainer },
          _react2.default.createElement(
            'a',
            { className: 'ant-dropdown-link' },
            selectLabel,
            ' ',
            _react2.default.createElement(_antd.Icon, { type: 'down' })
          )
        );
      }

      /**
       * Let's render the value field markup only if the operator
       * field is valid.
       */
      var valueMarkup = void 0;
      var fieldsConfig = void 0;
      if (_this.state.form.operator) {
        var _triggerEntity2 = triggerEntity,
            format = _triggerEntity2.format,
            supportedUnits = _triggerEntity2.supportedUnits,
            supportedValues = _triggerEntity2.supportedValues,
            valueField = _triggerEntity2.valueField,
            additionalFields = _triggerEntity2.additionalFields;
        /**
         * If the valueField is valueDecimal, valueString, or valueTime,
         * the read/writing to the field is straightforward since
         * we are only going to be dealing with one field for the data.
         */

        if (valueField === 'valueDecimal' || valueField === 'valueString') {
          fieldsConfig = [{
            name: valueField,
            format: format,
            children: supportedValues,
            decorator: {
              rules: [{ required: true, message: 'Missing value' }],
              initialValue: _this.state.form[valueField] ? _this.state.form[valueField] : null
            }
          }];

          if (format === "integer" || format === "decimal" || format === "currency" || format === "percent" || format === "numeric") {
            fieldsConfig[0].decorator.type = 'number';
            fieldsConfig[0].decorator.initialValue = _this.state.form[valueField] !== null ? parseFloat(_this.state.form[valueField]) : null;
          }
        } else {
          /**
           * On the other hand, if valueField is valueJson, this
           * is an indication that we have multiple data/form fields
           * that make up the entire value. For this, let's loop
           * over the different fields and render out the markup.
           *
           * For the interim, backend doesn't support sending FE
           * the schema of the actual valueJson field, so we will
           * maintain a mapping of valueJson schemas depending on
           * the trigger 'grouping'.
           *
           * Besides building out our main 'value' field, we will
           * check if there are supportedUnits. If there are,
           * this is an indication that there needs to be
           * a buddy unit field. ANT requires different markup than
           * the addonBefore/addonAfter prop for the form elements for
           * what we're trying to achieve, so we'll build that
           * out in accordance.
           */
          fieldsConfig = [{
            name: 'value',
            format: format,
            children: supportedValues,
            decorator: {
              rules: [{ required: true, message: 'Missing value' }]
            },
            buddy: supportedUnits && supportedUnits.length > 0 ? {
              name: 'unit',
              format: 'select',
              children: supportedUnits,
              decorator: {
                rules: [{ required: true, message: 'Missing unit' }]
              }
            } : null
          }];

          if (_this.state.form.valueJson && _this.state.form.valueJson.value) {
            fieldsConfig[0].decorator.initialValue = _this.state.form.valueJson.value;
          }

          if (_this.state.form.valueJson && _this.state.form.valueJson.unit) {
            fieldsConfig[0].buddy.decorator.initialValue = _this.state.form.valueJson.unit;
          }

          if (additionalFields && additionalFields.length > 0) {
            additionalFields.forEach(function (field, index) {
              if (field.format === 'location-lookup') {
                fieldsConfig.push({
                  name: 'location',
                  format: 'location-lookup',
                  options: {
                    fetchLocationsAction: _this.props.conditionActions.fetchLocations
                  },
                  formItem: {
                    label: 'in'
                  },
                  decorator: {
                    rules: [{ required: true, message: 'Missing location' }],
                    initialValue: _this.state.form.valueJson && _this.state.form.valueJson.loc && _this.state.form.valueJson.locLabel ? {
                      key: _this.state.form.valueJson.loc.toString(),
                      label: _this.state.form.valueJson.locLabel
                    } : { key: '', label: null }
                  }
                });
              }
            });
          }
        }

        valueMarkup = _react2.default.createElement(_ValidationInputs2.default, {
          fields: fieldsConfig,
          onChange: _this.onValidationInputsChange(valueField === "valueJson" ? "valueJson" : null),
          isValid: _this.updateValidationInputsValidation
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'edit-condition' },
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            _antd.Col,
            { span: 20 },
            _react2.default.createElement(
              _antd.Row,
              { type: 'flex', justify: 'start' },
              _react2.default.createElement(
                _antd.Col,
                { span: 5, className: 'm-r-16' },
                _react2.default.createElement(
                  FormItem,
                  triggersLoading,
                  factMarkup
                )
              ),
              _react2.default.createElement(
                _antd.Col,
                { className: 'text-align-center m-r-16' },
                _react2.default.createElement(
                  FormItem,
                  null,
                  operatorMarkup
                )
              ),
              _react2.default.createElement(
                _antd.Col,
                null,
                valueMarkup
              )
            )
          ),
          _react2.default.createElement(
            _antd.Col,
            { span: 4, className: 'text-align-right' },
            _react2.default.createElement(
              _antd.Button,
              {
                onClick: function onClick() {
                  return _this.saveCondition();
                },
                type: 'primary',
                className: 'condition-save-button',
                disabled: !_this.isFormValid()
              },
              _react2.default.createElement(_antd.Icon, { type: 'check' })
            ),
            _react2.default.createElement(
              _antd.Button,
              {
                onClick: function onClick() {
                  return _this.cancelSaveCondition();
                },
                type: 'default',
                className: 'condition-cancel-save-button'
              },
              _react2.default.createElement(_antd.Icon, { type: 'close' })
            )
          )
        )
      );
    }, _this.readOnlyView = function () {
      var _this$props4 = _this.props,
          condition = _this$props4.condition,
          meta = _this$props4.meta,
          conditionActions = _this$props4.conditionActions,
          conditionGroupID = _this$props4.conditionGroupID,
          ruleBranchID = _this$props4.ruleBranchID;
      var operators = meta.operators,
          triggers = meta.triggers;

      return _react2.default.createElement(
        'div',
        { className: 'read-only-condition' },
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            _antd.Col,
            { span: 20, className: 'show-white-space' },
            (0, _selectors.conditionDescriptionBuilder)({ condition: condition, operators: operators, triggers: triggers })
          ),
          _react2.default.createElement(
            _antd.Col,
            { span: 4, className: 'text-align-right' },
            _react2.default.createElement(_antd.Button, {
              icon: 'edit',
              size: 'large',
              className: 'condition-edit-button',
              onClick: function onClick() {
                conditionActions.edit(condition.id);
              }
            }),
            _react2.default.createElement(_antd.Button, {
              icon: 'close',
              size: 'large',
              className: 'condition-remove-button',
              onClick: function onClick() {
                conditionActions.remove(condition.id, conditionGroupID, ruleBranchID);
              }
            })
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Condition, [{
    key: 'componentWillMount',


    /**
     * When a Condition is initialized, we pass the data to its
     * state. If the condition data is invalid, it will immediately
     * dispatch an action to "edit" it. This is done so that when
     * we do pass in valid data, it should be rendered as read-only.
     */
    value: function componentWillMount() {
      var _this2 = this;

      var _props = this.props,
          conditionActions = _props.conditionActions,
          condition = _props.condition;
      var id = condition.id,
          fact = condition.fact,
          operator = condition.operator,
          valueJson = condition.valueJson,
          valueDecimal = condition.valueDecimal,
          valueString = condition.valueString;


      this.setState({
        form: {
          fact: fact,
          operator: operator,
          valueJson: valueJson,
          valueDecimal: valueDecimal,
          valueString: valueString
        }
      }, function () {
        // dispatch edit for this condition if the form is invalid
        if (!_this2.isFormValid()) {
          conditionActions.edit(id);
        }
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.editing !== nextProps.editing || this.props.condition !== nextProps.condition || this.props.meta !== nextProps.meta || this.props.ruleSettings !== nextProps.ruleSettings || this.state !== nextState;
    }

    /**
     * We check if the form is valid here.
     * The condition is considered valid if there is a presence of
     * fact, operator and (valueDecimal OR valueString OR valueJson (needs to not be empty)).
     */

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          editing = _props2.editing,
          ruleSettings = _props2.ruleSettings;
      var fact = this.state.form.fact;

      var conditionRender = editing ? this.editView() : this.readOnlyView();

      return _react2.default.createElement(
        'div',
        { className: 'condition__component' },
        _react2.default.createElement(
          _antd.Row,
          null,
          conditionRender
        ),
        _react2.default.createElement(
          _antd.Row,
          null,
          (0, _helpers.getConditionRestrictionMessage)(ruleSettings, fact)
        )
      );
    }
  }]);
  return Condition;
}(_react2.default.Component), _class.propTypes = {
  condition: _propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    fact: _propTypes2.default.string,
    operator: _propTypes2.default.string,
    valueJson: _propTypes2.default.object,
    valueString: _propTypes2.default.string,
    valueDecimal: _propTypes2.default.number
  }).isRequired,
  conditionActions: _propTypes2.default.shape({
    edit: _propTypes2.default.func.isRequired,
    cancelEdit: _propTypes2.default.func.isRequired,
    update: _propTypes2.default.func.isRequired,
    remove: _propTypes2.default.func.isRequired,
    fetchLocations: _propTypes2.default.func.isRequired
  }).isRequired,
  conditionGroupID: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  ruleBranchID: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  editing: _propTypes2.default.bool,
  meta: _propTypes2.default.shape({
    triggers: _propTypes2.default.shape({
      data: _propTypes2.default.objectOf(_propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({
        alias: _propTypes2.default.string.isRequired
      })))).isRequired
    }).isRequired,
    operators: _propTypes2.default.shape({
      data: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired
      }))).isRequired
    }).isRequired,
    cascaderTriggersOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      value: _propTypes2.default.string.isRequired,
      label: _propTypes2.default.string.isRequired,
      children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired,
        children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
          value: _propTypes2.default.string.isRequired,
          label: _propTypes2.default.string.isRequired
        }))
      }))
    })),
    loading: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.string
  }).isRequired,
  builderActions: _propTypes2.default.func.isRequired,
  ruleSettings: _propTypes2.default.shape({
    aggregationLevel: _propTypes2.default.oneOf(['FB_CAMPAIGN', 'FB_ADSET', 'FB_AD']),
    dataRangeRelative: _propTypes2.default.string,
    dataRangeAbsoluteStart: _propTypes2.default.string,
    dataRangeAbsoluteEnd: _propTypes2.default.string,
    lastNDays: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
  }).isRequired
}, _class.defaultProps = {
  editing: false
}, _temp2);
exports.default = Condition;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Builder/components/Condition.js
// module id = 3784
// module chunks = 4